module.exports = __webpack_public_path__ + "static/media/word_example.c238e1eb.png";